import PropTypes from 'prop-types';

const InnerFormSection = ({
  className,
  title,
  headerLevel = 3,
  description,
  children,
}) => {
  const HeadingTag = `h${headerLevel}`;

  return (
    <section
      className={`cef-ui-inner-form-section${
        className ? ` ${className}` : ''
      }`}>
      {title && (
        <div className="fl ai-c">
          {/* Parses spans and styles them */}
          <HeadingTag
            className="ff-body fs-20 lh-1-4 tc-main m-0 cef-ui-inner-form-section__title fw-700"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </div>
      )}

      {description && <p className="fw-400">{description}</p>}

      {children}
    </section>
  );
};

InnerFormSection.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  headerLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default InnerFormSection;
